import { isApiClientError } from '../default/ApiResponseError'
import { captureApiError } from '../default/captureApiError'

/**
 * Logs a failed middleware call through captureApiError
 *
 * @param {string} url
 * @param {Error} error
 * @param {boolean} rethrow
 * @param {boolean} skipK6
 */
export function captureMiddlewareError(
  url,
  error,
  rethrow = true,
  skipK6 = false,
) {
  const website = window.location.href
  const isK6Test = new URL(website).searchParams.get('skiptesting')
  if (isK6Test && skipK6) {
    return
  }

  captureApiError(error, url, {
    metric: 'middleware-error',
    transactionName: `middleware-error@${url}`,
    tags: isK6Test ? { k6: 'true' } : {},
  })

  // a 4xx is logged, not reported as an error
  if (!isApiClientError(error)) {
    console.error(error)
  }

  if (rethrow) {
    throw error
  }
}
